import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_coach_listing = async (
  source_slug = "",
  search = "",
  profile_type = "",
  client_id = "",
  page = 0,
  limit = 24
) => {
  const requestObj = {
    path: `api/coach/list_coach?source_slug=${source_slug}&profile_type=${profile_type}&name=${search}&client_id=${client_id}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_coach = async (data) => {
  const requestObj = {
    path: `api/coach/add_coach`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const coach_details = async (id) => {
  const requestObj = {
    path: `api/coach/detail_coach/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const edit_coach = async (id, data) => {
  const requestObj = {
    path: `api/coach/update_coach/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_coach = async (id) => {
  const requestObj = {
    path: `api/coach/delete_coach/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
